import React from "react";
import { TicketV2 } from "../components/Pages/TicketV2";
import { PixConfirmationV2 } from "../components/Pages/PixConfirmationV2";
import { Navigate, Route } from "react-router-dom";
import { PixV2 } from "../components/Pages/PixV2";
import { PaymentV2 } from "../components/Pages/PaymentV2";
import { ProtectedRoute } from "../components/Atoms/ProtectedRoute";
import { VehicleV2 } from "../components/Pages/VehicleV2";
import { SurveyV2 } from "../components/Pages/SurveyV2";
import { LicenseV2 } from "../components/Pages/LicenseV2";
import { VehicleRegisterV2 } from "../components/Pages/VehicleRegisterV2";
import { AddressRegistration } from "../components/Pages/AddressRegistration";
import { ServicesV2 } from "../components/Pages/ServicesV2";
import { UserRegistration } from "../components/Pages/UserRegistration";
import { LoginRegister } from "../components/Pages/LoginRegister";
import { ConfirmAppointmentV2 } from "../components/Pages/ConfirmAppointmentV2";
import { ScheduleConfirmationV2 } from "../components/Pages/ScheduleConfirmationV2";
import { Login } from "../components/Pages/Login";
import { LayoutTemplate } from "../components/Templates/LayoutTemplate";
import { Delivery } from "../components/Pages/Delivery";
import { Store } from "../components/Pages/Store";
import { PixCancellation } from "../components/Pages/PixCancellation";
import { TicketCancellation } from "../components/Pages/TicketCancellation";
import { ConcessionaireAddressRegister } from "../components/Pages/ConcessionaireAdressRegister";
import { InvoiceV2 } from "../components/Pages/InvoiceV2";
import { DispatcherCustomer } from "../components/Pages/DispatcherCustomer";
import { DispatcherCustomerRegister } from "../components/Pages/DispatcherCustomerRegister";
import { DispatcherCustomerDetail } from "../components/Pages/DispatcherCustomerDetail";
import { RefundForm } from "../components/Pages/RefundForm";
import { ListItinerants } from "../components/Pages/ListItinerants";
import { DelayNotification } from "../components/Pages/DelayNotification";
import { ImpedimentRegister } from "../components/Pages/ImpedimentRegister";
import { Auth } from "../components/Pages/Auth";

export const useAgendamentoByIdRoutes = () => {
  return (
    <Route path="/agendamento/:uuidAgendamento?" element={<LayoutTemplate />}>
      <Route path="auth">
        <Route index element={<Auth />} />
        <Route path="login" element={<Login />} />
        <Route path="cadastro-usuario" element={<UserRegistration />} />
      </Route>
      <Route path="login" element={<Navigate to="../auth/login" replace />} />
      <Route
        path="cadastro-usuario"
        element={<Navigate to="../auth/cadastro-usuario" replace />}
      />
      <Route path="confirmar-horario" element={<ScheduleConfirmationV2 />} />
      <Route path="fatura" element={<InvoiceV2 />} />

      <Route
        path="confirmar-agendamento"
        element={<ConfirmAppointmentV2 />}
      />
      <Route path="login-cadastro" element={<LoginRegister />} />
      <Route path="domicilio" element={<Delivery />} />
      <Route path="loja" element={<Store />} />

      <Route path="despachante-cliente">
        <Route index element={<DispatcherCustomer />} />
        <Route
          path="cadastro-cliente"
          element={<DispatcherCustomerRegister />}
        />
        <Route path="detalhe-cliente" element={<DispatcherCustomerDetail />} />
      </Route>

      <Route path="itinerantes" element={<ListItinerants />} />

      <Route path="servicos">
        <Route index element={<ServicesV2 />} />
        <Route
          path="cadastro-endereco-concessionaria"
          element={<ConcessionaireAddressRegister />}
        />
        <Route path="cadastro-endereco" element={<AddressRegistration />} />
        <Route path="emplacamento" element={<LicenseV2 />} />
        <Route path="vistoria" element={<SurveyV2 />} />
        <Route path="veiculo" element={<VehicleV2 />} />
        <Route path="primeiro-registro" element={<VehicleRegisterV2 />} />
      </Route>

      <Route path="pagamento">
        <Route
          index
          element={
            <ProtectedRoute>
              <PaymentV2 />
            </ProtectedRoute>
          }
        />
        <Route path="pix">
          <Route index element={<PixV2 />} />
          <Route
            path="confirmacao-pagamento"
            element={<PixConfirmationV2 />}
          />
        </Route>
        <Route path="boleto" element={<TicketV2 />} />
        <Route path="cancelamento-pix" index element={<PixCancellation />} />
        <Route
          path="cancelamento-boleto"
          index
          element={<TicketCancellation />}
        />{" "}
        <Route path="formulario-reembolso" index element={<RefundForm />} />
      </Route>
      <Route path="comunicar-atraso" element={<DelayNotification />} />
      <Route path="registrar-impedimento" element={<ImpedimentRegister />} />
    </Route>
  );
};
